var render, staticRenderFns
import script from "./fileDownloadList.vue?vue&type=script&lang=js&"
export * from "./fileDownloadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67adc2fc",
  null
  
)

export default component.exports